<script setup lang="ts">
import { useUserStore } from '~/store/userStore';


const userStore = useUserStore();
const route = useRoute();
const router = useRouter();

const originData = computed(() => {
    console.log(router.options);
    return router.options.routes[0].children?.find(v => v.name === 'design-toc')?.children;
  })

  console.log(originData.value);

const sideBarRouteList = computed(() => {
    let tocRouterList = JSON.parse(JSON.stringify(originData.value));

    // tocRouterList = tocRouterList?.filter(v => v.meta.companyAdmin === undefined || v.meta.companyAdmin === userStore.getUserAdmin);
  
    tocRouterList?.forEach(route => {
      route = childrenAuthGroupSearch(route);
    })
    return tocRouterList;
	});
  
function childrenAuthGroupSearch(route: any){

if(route.children){
  for(let i = 0; i < route.children.length; i++){
    let child = route.children[i];

    if(child.children){
      childrenAuthGroupSearch(child);
    }

    if(!(!(child.meta && child.meta.userAuthGroup) || child.meta.userAuthGroup.includes(userStore.loginUserInfo?.authGroupSeq))){
      route.children.splice(i, 1);
      i--;
    }

    if(!(!(child.meta && child.meta.companyAdmin) || (child.meta.companyAdmin === userStore.loginUserInfo?.isCompAdminManager))){
      route.children.splice(i, 1);
      i--;
    }

  }
}
return route;
}

console.log(route);

function checkHover(e: Event){
  if(e.target.tagName === 'BUTTON'){
    console.log(e);
    console.log(e.target as HTMLElement);
  }
}

function test(a){
  console.log(a);
  // router.push('./')
}

</script>

<template>
  <div class="toc-design-sidebar">
    <div class="logo">
      <img src="@/assets/images/logo.svg" />
    </div>
    <div class="menu">
      <div 
        v-for="inRoute in sideBarRouteList"
        class="btn-wrapper mt-3"
        :class="route.href.includes(inRoute.path) === true ? 'select' : ''"
        @mouseover="checkHover"
        @click="router.push(`/design-toc/${inRoute.path}`)"
        >
        <button class="btn">
          <img class="icon" :src="inRoute.icon" />
          <span>{{ inRoute.meta.name }}</span></button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>